module.exports = __webpack_public_path__ + "img/protamin.86853c5e.jpg";